import { ReactNode } from "react";
import { EqualApproximately } from "lucide-react";
import { Link } from "@inertiajs/react";
import { LoginForm } from "./_form";
import AuthLayout from "@/layouts/auth-layout";

function SessionNew() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <Link
          href="/"
          className="flex items-center gap-2 self-center font-medium"
        >
          <div className="flex h-6 w-6 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <EqualApproximately className="size-4" />
          </div>
          Zero
        </Link>
        <LoginForm />
      </div>
    </div>
  );
}

SessionNew.layout = (page: ReactNode) => <AuthLayout children={page} />;

export default SessionNew;
